import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchInterest, fetchInterestCreate, editInterest,
} from "Actions/Admin/Setup/InterestActions";



/**
 * The Interest Edit Dialog
 */
class InterestEdit extends React.Component {
    // The Initial Data
    initialData = {
        interestID  : 0,
        name        : "",
        courseID    : 0,
        groupinterestID    : 0,
        description : "",
        emailText   : "",
        position    : "",
        status      : Status.getID("ACTIVE"),
        isActivity  : 0,
        hideLink    : 0,
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, position, fetchInterest, fetchInterestCreate } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchInterest(elemID);
                loading = true;
            // Load edit data
            } else {
                fetchInterestCreate();
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            if (elemID) {
                data = Utils.extend(this.initialData, elem);
            } else {
                data = { ...this.initialData, position };
            }
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editInterest(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose, courses, groupinterest } = this.props;
        const { data, loading, errors          } = this.state;

        return <EditDialog
            open={open}
            icon="interest"
            title={!!elemID ? "INTERESTS_EDIT_TITLE" : "INTERESTS_CREATE_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                name="name"
                label="INTERESTS_ITS_NAME"
                value={data.name}
                error={errors.name}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="select"
                name="groupinterestID"
                label="Grupo al que pertenece"
                value={data.groupinterestID}
                error={errors.groupinterestID}
                onChange={this.handleChange}
                options={groupinterest}
                withNone
            />
            <InputField
                type="select"
                name="courseID"
                label="INTERESTS_COURSE"
                value={data.courseID}
                error={errors.courseID}
                onChange={this.handleChange}
                options={courses}
                withNone
            />
            <InputField
                type="textarea"
                name="description"
                label="INTERESTS_DESCRIPTION"
                value={data.description}
                error={errors.description}
                onChange={this.handleChange}
                isRequired={Boolean(data.isActivity)}
            />
            <InputField
                type="textarea"
                name="emailText"
                label="INTERESTS_EMAIL_TEXT"
                value={data.emailText}
                error={errors.emailText}
                onChange={this.handleChange}
            />
            <InputField
                type="number"
                name="position"
                label="GENERAL_POSITION"
                value={data.position}
                error={errors.position}
                onChange={this.handleChange}
                shrinkLabel
            />
            <InputField
                type="select"
                name="status"
                label="GENERAL_STATUS"
                value={data.status}
                error={errors.status}
                onChange={this.handleChange}
                options={Status.getSelect()}
                withNone
                isRequired
                shrinkLabel
            />
            <InputField
                type="toggle"
                name="isActivity"
                label="INTERESTS_IS_ACTIVITY"
                value={data.isActivity}
                error={errors.isActivity}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="toggle"
                name="hideLink"
                label="INTERESTS_HIDE_LINK"
                value={data.hideLink}
                error={errors.hideLink}
                onChange={this.handleChange}
                isRequired
            />
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchInterest       : PropTypes.func.isRequired,
        fetchInterestCreate : PropTypes.func.isRequired,
        editInterest        : PropTypes.func.isRequired,
        open                : PropTypes.bool.isRequired,
        onClose             : PropTypes.func.isRequired,
        onSubmit            : PropTypes.func.isRequired,
        edition             : PropTypes.number.isRequired,
        position            : PropTypes.number.isRequired,
        courses             : PropTypes.array.isRequired,
        groupinterest       : PropTypes.array.isRequired,
        elem                : PropTypes.object.isRequired,
        elemID              : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition  : state.interest.edition,
            position : state.interest.position,
            courses  : state.interest.courses,
            groupinterest  : state.interest.groupinterest,
            elem     : state.interest.elem,
        };
    }
}

export default connect(InterestEdit.mapStateToProps, {
    fetchInterest, fetchInterestCreate, editInterest,
})(InterestEdit);
